import AuditContext from 'components/common/Audit/AuditContext';
import { useContext } from 'react';
import { Grid, Typography } from '@material-ui/core';
import { useSelector } from 'react-redux';

const AuditDrawerAppBarTitle = () => {
  const { item, selectorId } = useContext(AuditContext);
  const { subtitle, title } = useSelector((state) => selectorId(state, item));

  return (
    <Grid container direction="column">
      <Grid item>
        <Typography color="inherit" variant="h6">
          Audit Details - {title || ''}
        </Typography>
      </Grid>
      {title && subtitle && (
        <Grid item>
          <Typography color="textSecondary" variant="body1">
            {subtitle}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default AuditDrawerAppBarTitle;
